/**
 * CommonFontStyle.ts
 */
export class CommonFontStyle {
}
CommonFontStyle.ROTATE_DEVICE = "CommonFontStyle.ROTATE_DEVICE";
CommonFontStyle.DIALOG_TITLE = "CommonFontStyle.DIALOG_TITLE";
CommonFontStyle.DIALOG_MESSAGE = "CommonFontStyle.DIALOG_MESSAGE";
CommonFontStyle.DIALOG_BUTTON_0 = "CommonFontStyle.DIALOG_BUTTON_0";
CommonFontStyle.DIALOG_BUTTON_1 = "CommonFontStyle.DIALOG_BUTTON_1";
CommonFontStyle.DIALOG_BUTTON_2 = "CommonFontStyle.DIALOG_BUTTON_2";
CommonFontStyle.PRELOADER_MESSAGE = "CommonFontStyle.PRELOADER_MESSAGE";
CommonFontStyle.DEMO_PLAY_LABEL = "CommonFontStyle.DEMO_PLAY_LABEL";
CommonFontStyle.STAKE_SELECTOR_LABEL = "CommonFontStyle.STAKE_SELECTOR_LABEL";
CommonFontStyle.STAKE_SELECTOR_AMOUNT = "CommonFontStyle.STAKE_SELECTOR_AMOUNT";
CommonFontStyle.STAKE_SELECTOR_VALUE_BUTTON = "CommonFontStyle.STAKE_SELECTOR_VALUE_BUTTON";
CommonFontStyle.OPTIONS_MENU = "CommonFontStyle.OPTIONS_MENU";
CommonFontStyle.SIGNPOSTING_TITLE = "CommonFontStyle.SIGNPOSTING_TITLE";
CommonFontStyle.SIGNPOSTING_BODY = "CommonFontStyle.SIGNPOSTING_BODY";
CommonFontStyle.INSTRUCTIONS_TOP_MESSAGE = "FontStyle.INSTRUCTIONS_TOP_MESSAGE";
CommonFontStyle.INSTRUCTIONS_BOTTOM_MESSAGE = "FontStyle.INSTRUCTIONS_BOTTOM_MESSAGE";
CommonFontStyle.INSTRUCTIONS_SPIN_PRICE = "FontStyle.INSTRUCTIONS_SPIN_PRICE";
CommonFontStyle.CHECK_BOX = "CommonFontStyle.CHECK_BOX";
CommonFontStyle.RTP_INFO = "CommonFontStyle.RTP_INFO";
CommonFontStyle.RESPONSIBLE_GAMING_PANEL_TITLE = "FontStyle.RESPONSIBLE_GAMING_PANEL_TITLE";
CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_DESELECTED = "FontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_DESELECTED";
CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_SELECTED = "FontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_SELECTED";
/**
 * LoaderFontStyle.ts
 */
export class LoaderFontStyle {
}
LoaderFontStyle.PROGRESS = "LoaderFontStyle.PROGRESS";
LoaderFontStyle.VERSION = "LoaderFontStyle.VERSION";
// LoaderDialog.ts
LoaderFontStyle.PLAY_BUTTON = "LoaderFontStyle.PLAY_BUTTON";
LoaderFontStyle.GUIDE_BODY = "LoaderFontStyle.GUIDE_BODY";
//# sourceMappingURL=CommonFontStyle.js.map